/*=========================================================================================
  File Name: moduleChatGetters.js
  Description: Chat Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// import contacts from '@/views/apps/chat/contacts'

export default {
	chatDataOfUser: (state) => (id) => {
		return state.chats.find((chat) => chat.key === id);
	},
	contactImg: (state) => (id) => {
		return state.contactsImages.find((contactsImage) => contactsImage.id === id);
	},
	chatContacts: (state, getters) => {
		return chatContacts;
	},
	contacts: (state) =>
		state.contacts.filter((contact) =>
			contact.username.toLowerCase().includes(state.chatSearchQuery.toLowerCase())
		),
	contact: (state) => (contactId) => state.contacts.find((contact) => contact.id === contactId),
	chats: (state) =>
		state.chats.filter((chat) => chat.name.toLowerCase().includes(state.chatSearchQuery.toLowerCase())),
	chatUser: (state, getters, rootState) => (id) =>
		state.contacts.find((contact) => contact.uid === id) || rootState.AppActiveUser,

	chatLastMessaged: (state, getters) => (id) => {
		if (getters.chatDataOfUser(id)) return getters.chatDataOfUser(id).msg.slice(-1)[0];
		else return false;
	},
	chatUnseenMessages: (state, getters) => (id) => {
		let unseenMsg = 0;
		const chatData = getters.chatDataOfUser(id);
		if (chatData) {
			chatData.msg.map((msg) => {
				if (!msg.isSeen && !msg.isSent) unseenMsg++;
			});
		}
		return unseenMsg;
	},
	contactFcmToken: (state) => (contactId) => state.contactsFcm.find((contact) => contact.contactId === contactId),
};
